"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
require("core-js/modules/es6.object.assign");
const react_1 = __importDefault(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
const atoms_1 = require("@components/atoms");
const _theme_1 = require("@theme");
const _utils_1 = require("@utils"); // Component
var LayoutSubtitle = function LayoutSubtitle(_ref) {
    var title = _ref.title, className = _ref.className, _ref$alignLeft = _ref.alignLeft, alignLeft = _ref$alignLeft === void 0 ? false : _ref$alignLeft;
    return /*#__PURE__*/ react_1.default.createElement(atoms_1.Padding, {
        className: className,
        halfPadding: true
    }, /*#__PURE__*/ react_1.default.createElement(Subtitle, Object.assign({
        alignLeft: alignLeft
    }, {
        dangerouslySetInnerHTML: {
            __html: title
        }
    })));
}; // Styling
var Subtitle = styled_components_1.default.div.withConfig({
    displayName: "LayoutSubtitle__Subtitle",
    componentId: "sc-1g5y48b-0"
})(["", " text-align:", ";&::before,&::after{display:block;height:0;width:0;content:'';}&::before{margin-top:calc((1 - 1.3) * 1em);}&::after{margin-bottom:calc((1 - 1.55) * 1em);}", "{&::after{margin-bottom:calc((1 - 1.5) * 1em);}}"], _theme_1.type.p, function (props) {
    return !!props.alignLeft ? 'left' : 'center';
}, _utils_1.mediaQuery('desktop')); // Typing
exports.default = LayoutSubtitle;
